@reference "~/styles.css";

@layer components {
	.textarea {
		@apply w-full bg-white rounded-sm border text-grey-800 cursor-text outline-hidden resize-none motion-safe:transition-colors;
		@apply placeholder:text-grey-600;
		@apply read-only:bg-grey-100 read-only:text-grey-500 read-only:border-grey-400! read-only:placeholder:text-grey-400;
		@apply aria-disabled:cursor-not-allowed;
		@apply aria-busy:cursor-wait;
		@apply focus-visible:ring-2;
	}

	/* VARIANTS */

	.neutral {
		@apply border-grey-400 ring-primary-500/30 hover:border-primary-500 focus-visible:border-primary-500;
	}

	.error {
		@apply border-red-500 ring-red-500/30;
	}

	/* SIZE */

	.sm {
		@apply px-2 py-1 text-xs;
	}

	.md {
		@apply px-3 py-2 text-13 leading-5;
	}

	.lg {
		@apply px-4 py-3 text-sm;
	}
}
